import { Avatar, Grid, styled } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { colors } from "@zapalacorp/tokens";
import { FiTrash2 } from "react-icons/fi";

export const CommentCard = styled(Grid)(() => ({
  width: "100%",
  border: "1px solid",
  borderRadius: "12px",
  padding: "24px",
  borderColor: colors.gray200,
  marginTop: "16px",
}));

export const CommentHeader = styled("div")(() => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
}));

export const CommentAvatar = styled(Avatar)(() => ({
  width: "40px",
  height: "40px",
}));

export const DeleteCommentIcon = styled(FiTrash2)(() => ({
  cursor: "pointer",
}));

export const CommentHeaderInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: "16px",
  justifyContent: "space-between",
}));

export const CommentTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: colors.gray600,
}));

export const CommentSubtitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  color: colors.gray500,
}));

export const CommentText = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: colors.gray600,
  marginTop: "16px",
}));
